/* Auro & Co product cards and quick view. See snippets/card-product.liquid and sections/auro-quick-view.liquid. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var modal, body, toast, toastTimer, lastFocus;

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  function post(url, data) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.text().then(function (t) {
        var j;
        try { j = JSON.parse(t); } catch (e) { throw new Error('Sorry, that did not work. Please try again.'); }
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Sorry, that did not work. Please try again.');
        return j;
      });
    });
  }

  function refreshCartUI() {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
          var inner = d.querySelector('.shopify-section');
          bubble.innerHTML = inner ? inner.innerHTML : d.body.innerHTML;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && s['cart-drawer']) {
          var d2 = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
          var fresh = d2.querySelector('#CartDrawer');
          var cur = drawer.querySelector('#CartDrawer');
          var freshDrawer = d2.querySelector('cart-drawer');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      })
      .catch(function () {});
  }

  function syncCards() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var map = {};
        cart.items.forEach(function (it) {
          var props = it.properties || {};
          if (Object.keys(props).length || it.selling_plan_allocation) return;
          var m = map[it.variant_id] || { qty: 0, key: it.key };
          m.qty += it.quantity;
          m.key = it.key;
          map[it.variant_id] = m;
        });
        $$('[data-ac-card]').forEach(function (card) {
          var m = map[card.dataset.variantId] || { qty: 0, key: '' };
          setCard(card, m.qty, m.key);
        });
      })
      .catch(function () {});
  }

  function setCard(card, qty, key) {
    var add = $('[data-ac-add]', card);
    var stepper = $('[data-ac-stepper]', card);
    if (!add || !stepper) return;
    card.dataset.lineKey = key || '';
    $('[data-ac-qty]', card).textContent = qty;
    add.hidden = qty > 0;
    stepper.hidden = qty === 0;
    card.classList.toggle('is-in-cart', qty > 0);
  }

  function busy(card, on) {
    card.classList.toggle('is-busy', on);
    $$('button', $('.ac-card__actions', card) || card).forEach(function (b) { b.disabled = on; });
  }

  function showToast(text, isError) {
    if (!toast) return;
    $('[data-ac-toast-text]', toast).textContent = text;
    $('[data-ac-open-cart]', toast).hidden = !!isError;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-on');
      setTimeout(function () { toast.hidden = true; }, 250);
    }, 3500);
  }

  function afterChange(message) {
    return Promise.all([refreshCartUI(), syncCards()]).then(function () { if (message) showToast(message); });
  }

  function cardAction(card, kind) {
    var qty = parseInt($('[data-ac-qty]', card).textContent, 10) || 0;
    var req;
    if (kind === 'add' || (kind === 'plus' && !card.dataset.lineKey)) {
      req = post('cart/add.js', { items: [{ id: Number(card.dataset.variantId), quantity: 1 }] });
    } else {
      req = post('cart/change.js', { id: card.dataset.lineKey, quantity: kind === 'plus' ? qty + 1 : Math.max(qty - 1, 0) });
    }
    busy(card, true);
    req
      .then(function (res) {
        var msg = kind === 'minus' ? (qty - 1 > 0 ? 'Basket updated' : 'Removed from your basket') : 'Added to your basket';
        if (kind === 'plus' && res && res.items && card.dataset.lineKey) {
          var line = res.items.filter(function (i) { return i.key === card.dataset.lineKey; })[0];
          if (line && line.quantity < qty + 1) msg = 'Sorry, there are no more in stock';
        }
        return afterChange(msg);
      })
      .catch(function (e) { showToast(e.message, true); })
      .finally(function () { busy(card, false); });
  }

  /* Quick view */
  var closeTimer = null;
  var reqId = 0;
  function setInert(on) {
    $$('body > *').forEach(function (el) {
      if (el.contains(modal)) return;
      if (on) { if (!el.hasAttribute('inert')) { el.setAttribute('inert', ''); el.dataset.acInert = '1'; } }
      else if (el.dataset.acInert) { el.removeAttribute('inert'); delete el.dataset.acInert; }
    });
  }
  function openQuickView(url) {
    if (!modal) return;
    clearTimeout(closeTimer);
    var my = ++reqId;
    lastFocus = document.activeElement;
    body.innerHTML = '<div class="ac-modal__loading" role="status">Loading…</div>';
    modal.hidden = false;
    document.documentElement.classList.add('ac-modal-open');
    setInert(true);
    var panel = $('.ac-modal__panel', modal);
    if (panel) panel.focus();
    requestAnimationFrame(function () { modal.classList.add('is-on'); });
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=auro-qv-product')
      .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
      .then(function (html) {
        if (my !== reqId || modal.hidden) return;
        var d = new DOMParser().parseFromString(html, 'text/html');
        var qv = d.querySelector('[data-ac-qv-root]');
        if (!qv) throw new Error();
        body.innerHTML = '';
        body.appendChild(qv);
        initQuickView(qv);
        if (panel) panel.focus();
      })
      .catch(function () {
        if (my !== reqId) return;
        body.innerHTML = '<div class="ac-modal__loading" role="alert">Sorry, this product could not be loaded. <a href="' + url + '">Open the product page</a></div>';
      });
  }

  function closeQuickView() {
    if (!modal || modal.hidden) return;
    reqId++;
    modal.classList.remove('is-on');
    document.documentElement.classList.remove('ac-modal-open');
    setInert(false);
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { modal.hidden = true; body.innerHTML = ''; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function bindTrap() {
    if (!modal) return;
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled]),select,input,[tabindex]:not([tabindex="-1"])', modal).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) { e.preventDefault(); return; }
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === a || !modal.contains(document.activeElement) || document.activeElement === $('.ac-modal__panel', modal))) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
  }

  function initQuickView(qv) {
    var variants = [];
    try { variants = JSON.parse($('[data-ac-qv-variants]', qv).textContent); } catch (e) {}
    var select = $('[data-ac-qv-variant]', qv);
    var addBtn = $('[data-ac-qv-add]', qv);
    var priceEl = $('[data-ac-qv-price]', qv);
    var qtyEl = $('[data-ac-qv-qty]', qv);
    var msg = $('[data-ac-qv-msg]', qv);
    var media = $('.ac-qv__media', qv);
    var dots = $$('.ac-qv__dot', qv);

    function update() {
      if (!select) return;
      var v = variants.filter(function (x) { return String(x.id) === select.value; })[0];
      if (!v) return;
      addBtn.dataset.variantId = v.id;
      priceEl.textContent = money.format(v.price / 100);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to basket' : 'Sold out';
      var badge = $('[data-ac-qv-badge]', qv);
      if (badge) badge.hidden = true;
    }
    if (select) select.addEventListener('change', update);

    if (media && dots.length) {
      media.addEventListener('scroll', function () {
        var i = Math.round(media.scrollLeft / media.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }, { passive: true });
    }

    qv.addEventListener('click', function (e) {
      var q = parseInt(qtyEl.textContent, 10) || 1;
      if (e.target.closest('[data-ac-qv-minus]')) qtyEl.textContent = Math.max(1, q - 1);
      if (e.target.closest('[data-ac-qv-plus]')) qtyEl.textContent = Math.min(99, q + 1);
      if (e.target.closest('[data-ac-qv-add]') && !addBtn.disabled) {
        addBtn.disabled = true;
        msg.hidden = true;
        post('cart/add.js', { items: [{ id: Number(addBtn.dataset.variantId), quantity: q }] })
          .then(function () { closeQuickView(); return afterChange('Added to your basket'); })
          .catch(function (err) { msg.textContent = err.message; msg.hidden = false; })
          .finally(function () { addBtn.disabled = false; });
      }
    });
  }

  function start() {
    modal = $('[data-ac-modal]');
    body = modal ? $('[data-ac-modal-body]', modal) : null;
    toast = $('[data-ac-toast]');
    bindTrap();
    window.AuroCards = { sync: syncCards };

    document.addEventListener('click', function (e) {
      var t = e.target;
      var qvBtn = t.closest('[data-ac-qv]');
      if (qvBtn) {
        var c = qvBtn.closest('[data-ac-card]');
        if (c) { e.preventDefault(); openQuickView(c.dataset.productUrl); }
        return;
      }
      var card = t.closest('[data-ac-card]');
      if (card) {
        if (t.closest('[data-ac-add]')) return cardAction(card, 'add');
        if (t.closest('[data-ac-plus]')) return cardAction(card, 'plus');
        if (t.closest('[data-ac-minus]')) return cardAction(card, 'minus');
      }
      if (t.closest('[data-ac-close]')) return closeQuickView();
      if (t.closest('[data-ac-open-cart]')) {
        var drawer = document.querySelector('cart-drawer');
        toast.classList.remove('is-on');
        toast.hidden = true;
        if (drawer && drawer.open) drawer.open(); else window.location.href = root + 'cart';
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });
    /* On a collection page, remember which collection a product was opened from (product page breadcrumbs and
       "More in", assets/auro-pdp.js). Session only; nothing personal is kept. */
    var fromColl = /^\/collections\/([a-z0-9][a-z0-9_-]*)(?:\/[^/]*)?\/?$/i.exec(window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/collections\/)/i, ''));
    if (fromColl && ['all', 'vendors', 'types'].indexOf(fromColl[1].toLowerCase()) < 0) {
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href*="/products/"]');
        if (!a || !a.closest('main, #MainContent, [data-ac-modal]')) return;
        var m = /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
        if (!m) return;
        try { window.sessionStorage.setItem('auro_pdp_from', JSON.stringify({ c: fromColl[1], p: decodeURIComponent(m[1]), t: Date.now() })); } catch (err) { /* private mode */ }
      }, true);
    }
    /* Keep cards in step with the basket when the cart drawer changes it, or the page comes back from history. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) syncCards(); });
    if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { syncCards(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();